export default __webpack_public_path__ + "07125185235b59a8322107749bc97f15.png";